/*
 * Staff Messages
 *
 * This contains all the text for the Staff container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Tickets';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Tickets',
  },
});
